import RiskProfileContainer from "./RiskProfileContainer";
import RiskProfileStore from "./RiskProfileStore";

export default RiskProfileStore(RiskProfileContainer);